var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShowBodyPain)?_c('div',{staticClass:"body-pain"},[_c('h4',{staticClass:"body-pain__heading"},[_vm._v(" 体の痛み ")]),_c('p',{staticClass:"body-pain__text"},[_vm._v(" "+_vm._s(_vm.activity.bodyPain.text)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }